/**
 * Nền tảng triển khai của đơn vị
 */
export default {
  None: 1, // Mã QHNS triển khai riêng lẻ như hiện tại
  IHOSPlatform: 2, // Mã QHNS nằm trong nền tảng IHOS
  IGOVPlatform: 3, // Mã QHNS nằm trong nền tảng IGOV
  MPLPlatform: 4, // Chỉ dùng làm signal redirect từ MPL Core, KHÔNG xuất hiện trong DB tenant.platform_type
};
